import process from 'process';

window.process = process;
